(function () {
	'use strict';
	$(document).ready(function () {

		if ($('.distances').length) {
			function searchDistance() {
				var stationStartVal = $('input[name="stacja-nadania"]').val();
				var stationFinishVal = $('input[name="stacja-koncowa"]').val();

				var stationStartId = $('input[name="stacja-nadania"]').attr('data-station-id');
				var stationFinishId = $('input[name="stacja-koncowa"]').attr('data-station-id');

				var nonce = fhGetConfig('nonce');

				$.ajax({
					url: "/wp-admin/admin-ajax.php",
					method: "post",
					timeout: 10000,
					data: {
						action: "search_distance",
						station_start_val: stationStartVal,
						station_finish_val: stationFinishVal,
						station_start_id: stationStartId,
						station_finish_id: stationFinishId,
						nonce: nonce,
					},
					success: function (data) {
						$('#distance-results').html(data);
						$('#distance-results').slideDown();
					},
					error: function () {
						$('.ajax-error').slideDown();
					},
					beforeSend: function () {
						$('#distance-results').slideUp();
						$('.ajax-error').slideUp();
						$('.ajax-loading').slideDown();
					},
					complete: function () {
						$('.ajax-loading').slideUp();
					},
				});
			}

			$('input[required]').on('change', function() {
				if ($(this).val()) {
					$(this).siblings('.form-error').slideUp();
				} else {
					$(this).siblings('.form-error').slideDown();
				}
			});

			$('#distances-form').on('submit', function (e) {
				e.preventDefault();

				$('#distances-form .form-error').hide();
				var isAllValid = true;

				var fieldsToValidationText = $('input[required]');
				$(fieldsToValidationText).each(function (index, element) {
					if (!$(element).val()) {
						$(this).siblings('.form-error').slideDown();
						isAllValid = false;
					}
				});

				if (!isAllValid) {
					$("html, body").animate({
						scrollTop: $('.form-error[style*="display: block"]').offset().top - 120
					}, 1000);
					return;
				}

				searchDistance();
			});

		}

	});
}(jQuery));
